import WarningIcon from '@mui/icons-material/Warning';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';

import CloseButton from 'reservations/base/components/CloseButton';
import { MEDIUM_SOY } from 'reservations/brand/constants';

type Props = {
  message: string;
  isError: boolean;
};

export const SnackbarMessage = ({ message, isError }: Props) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      fontSize: '11px',
      letterSpacing: '0.2px',
      py: '12px'
    }}
  >
    {isError && (
      <WarningIcon
        data-testid="warning-icon"
        sx={{ marginRight: '1rem', fontSize: '30px', color: MEDIUM_SOY }}
      />
    )}
    {message}
  </Box>
);

const useEnqueueSnackbar = (variant: 'success' | 'error') => {
  const { closeSnackbar, enqueueSnackbar: _enqueueSnackbar } = useSnackbar();
  const isError = variant === 'error';

  const enqueueSnackbar = (key: string, message: string) =>
    _enqueueSnackbar(<SnackbarMessage message={message} isError={isError} />, {
      key,
      variant,
      ...(isError && {
        action: () => <CloseButton onClick={() => closeSnackbar(key)} />
      })
    });

  return enqueueSnackbar;
};

export const useSuccessSnackbar = () => {
  const enqueueSuccessSnackbar = useEnqueueSnackbar('success');
  return enqueueSuccessSnackbar;
};

export const useErrorSnackbar = () => {
  const enqueueErrorSnackbar = useEnqueueSnackbar('error');
  return enqueueErrorSnackbar;
};
